import Web3 from "web3";
import Web3Modal from "web3modal";
import WalletConnectProvider from "@walletconnect/web3-provider";

var web3;
var selectedAccount = ''

export async function connectToWallet() {
    const providerOptions = {   
        injected: {
            display: {
              logo: "data:image/gif;base64,INSERT_BASE64_STRING",
              name: "Injected",
              description: "Connect with the provider in your Browser"
            },
            package: null
          },
          // Example with WalletConnect provider
          walletconnect: {
            display: {
              logo: "data:image/gif;base64,INSERT_BASE64_STRING",
              name: "Mobile",
              description: "Scan qrcode with your mobile wallet"
            },
            package: WalletConnectProvider,
            options: {
              infuraId: "https://ropsten.infura.io/v3/f800b02fca114d6f8cda7cfa30ab1e24" // required
            }
          }
    };


    const web3Modal = new Web3Modal({
        network: "ropsten", // optional
        cacheProvider: true, // optional
        providerOptions,
        theme: "dark" // required
    });
    const provider = await web3Modal.connect();


    web3 = new Web3(provider);
    const accounts = await web3.eth.getAccounts();
    selectedAccount = accounts[0]

    // MetaMask does not give you all accounts, only the selected account
    console.log("Got accounts", accounts);

    var balance = await web3.eth.getBalance(selectedAccount)
    console.log(balance)
    return { 
        selectedAccount: selectedAccount,
        accountBalance: balance
    }
}